class DiscoverySection extends HTMLElement {
  constructor() {
    super();
    this.headingEl = this.querySelector(".collection-heading");
    this.dropdownEl = this.querySelector(".collection-title");
    this.sliders = this.querySelectorAll("[data-slider]");
    this.navLink = this.querySelector("[data-nav-link ");
    this.navTitle = this.querySelector("[data-nav-title]");
    this.recentlyViewedWrapper = this.querySelector("[data-products-html]");
    this.storage = new PIStorage("pi-recently-viewed");

    this.initEvents();
  }

  connectedCallback() {
    this.recentlyViewedProducts = this.storage.get();
    if (
      this.recentlyViewedProducts &&
      this.recentlyViewedProducts.length >= 4
    ) {
      this.setupRecentlyViewSlider();
    }
  }

  initEvents() {
    this.dropdownEl.addEventListener("click", this.handleDropdown.bind(this));
    document.addEventListener("click", (e) => {
      if (!this.dropdownEl.contains(e.target)) {
        this.removeAttribute("data-open");
      }
    });
  }

  handleDropdown(event) {
    const target = event.target;
    if (target.classList.contains("dropdown-list")) {
      this.headingEl.textContent = target.textContent;
      this.navTitle.textContent = target.textContent;
      this.navLink.href = target.dataset.href;
      const sliderIndex = parseInt(target.dataset.collection);
      this.sliders.forEach((slider, index) => {
        if (index == sliderIndex) {
          slider.removeAttribute("hidden");
        } else {
          slider.setAttribute("hidden", "");
        }
      });
    }
    this.toggleAttribute("data-open");
  }

  async getProductHtml(handle, index) {
    const fetchData = await fetch(
      `/products/${handle}/?section_id=picasso-static-card-product`
    );
    const response = await fetchData.text();
    const doc = new DOMParser().parseFromString(response, "text/html");
    const productEl = doc.querySelector("[data-scroll-id]");
    productEl.dataset.scrollId = index + 1;
    return productEl.outerHTML;
  }

  async setupRecentlyViewSlider() {
    // console.log(this.recentlyViewedProducts);
    this.recentlyViewedProducts = this.recentlyViewedProducts.sort(
      (a, b) => b.price - a.price
    );

    // console.log(this.recentlyViewedProducts);
    const htmlArray = await Promise.all(
      this.recentlyViewedProducts.map((product, index) =>
        this.getProductHtml(product.handle, index)
      )
    );

    if (this.recentlyViewedWrapper) {
      this.recentlyViewedWrapper.innerHTML = htmlArray.join("");
      this.dataset.view = "pirecentlyviewed";
      theme.reinitProductGridItem();
    }
  }
}
customElements.define("discovery-section", DiscoverySection);
